import { Map, List } from 'immutable';

export default new Map({
  account: new Map({
    authUser: new Map({
      organisations: new List([]),
    }),
    accessToken: 'demo-access-token',
  }),
  device: new Map({
    deviceId: 'demo',
    location: new Map({
      id: 1234,
      name: 'Demo Land',
    }),
  }),
  settings: new Map({
    organisation: new Map({
      pinDetails: new Map({
        length: 4,
      }),
    }),
  }),
});



// WEBPACK FOOTER //
// ./src/store/demo-mode-initial-state.js